import {create} from 'zustand';
import {MobileRefuseModalStore} from './types';

export const useMobileRefuseModalStore = create<MobileRefuseModalStore>(set => ({
	refuseModal: false,
	setRefuseModal: value => set({refuseModal: value}),
}));
